module.exports = __webpack_public_path__ + "media/login/logo-77c74773.png";